import React from 'react';
import { useEditorActions } from '../../store/editorStore.jsx';

export function DividerCanvas({ block }) {
  const { style = 'solid', color = '#dee2e6', width = 1 } = block.attrs;
  return (
    <div className="editor-divider-block py-1">
      <hr style={{ borderTop: `${width}px ${style} ${color}`, margin: 0 }} />
    </div>
  );
}

export function DividerInspector({ block }) {
  const { updateAttrs } = useEditorActions();
  const { style = 'solid', color = '#dee2e6', width = 1 } = block.attrs;

  return (
    <div className="p-3">
      <div className="mb-3">
        <label className="form-label fw-semibold small">Style</label>
        <select
          className="form-select form-select-sm"
          value={style}
          onChange={(e) => updateAttrs(block.id, { style: e.target.value })}
        >
          <option value="solid">Solid</option>
          <option value="dashed">Dashed</option>
          <option value="dotted">Dotted</option>
          <option value="double">Double</option>
        </select>
      </div>
      <div className="mb-3">
        <label className="form-label fw-semibold small">Color</label>
        <input
          type="color"
          className="form-control form-control-sm form-control-color"
          value={color}
          onChange={(e) => updateAttrs(block.id, { color: e.target.value })}
        />
      </div>
      <div className="mb-3">
        <label className="form-label fw-semibold small">Thickness (px)</label>
        <input
          type="range"
          className="form-range"
          min={1}
          max={8}
          value={width}
          onChange={(e) => updateAttrs(block.id, { width: Number(e.target.value) })}
        />
        <small className="text-muted">{width}px</small>
      </div>
    </div>
  );
}
